module.exports = __webpack_public_path__ + "assets/kentico.ee650749.svg";